import { formatValue, lengthLimit, showLoader, printWorkAround } from '../data-viz-helpers.js'

customElements.define('zero-gauge', class extends HTMLElement {
    static observedAttributes = ['data-value', 'data-label', 'data-bg', 'data-fill', 'data-help', 'data-heading']

    constructor() {
        super().attachShadow({mode: 'open'})

        this.height = 150
        this.width = 300
    }

    connectedCallback() {
        this.getProps()
        this.shadowRoot.innerHTML = showLoader([this.dataset.value], this.render())
    }

    attributeChangedCallback(name, oldVal, newVal) {
        if(oldVal !== newVal) {
            this.connectedCallback()
        }
    }

    getProps() {
        this.bg = this.dataset.bg ?? 'var(--color-4-lt)'
        this.fill = this.dataset.fill ?? 'var(--color-4-dk)'
        this.format = this.dataset.format ?? ''
        this.heading = this.dataset.heading ?? 'xxxxxxxxx'
        this.value = parseFloat(this.dataset.value) ?? 'XX'
    }

    createHeading() {
        return `
            <p class="heading">${lengthLimit(this.heading, 22)}</p>
        `
    }

    createGauge() {
        const shapePath = 'M60.297,142.641c-0.334,4.148 -3.798,7.345 -7.96,7.345c-11.336,0.014 -32.484,0.014 -44.126,0.014c-2.194,0 -4.292,-0.901 -5.803,-2.492c-1.51,-1.592 -2.301,-3.734 -2.186,-5.925c4.382,-78.878 69.815,-141.583 149.778,-141.583c79.963,0 145.396,62.705 149.767,141.584c0.115,2.188 -0.675,4.327 -2.183,5.916c-1.509,1.589 -3.604,2.489 -5.795,2.489c-11.642,0.011 -32.79,0.011 -44.126,0.011c-4.169,-0 -7.64,-3.202 -7.974,-7.358c-3.735,-46.237 -42.494,-82.642 -89.689,-82.642c-47.195,0 -85.954,36.405 -89.703,82.641Z'
        const percent = this.value * 100

        return `
            <clipPath id="clip">
                <path 
                    id="gauge"
                    d="${shapePath}"
                    transform="translate(0 0)" />
            </clipPath>

            <use href="#gauge" fill="white"></use>

            <g clip-path="url(#clip)">
                <rect 
                    width="300" 
                    height="300" 
                    rx="0" 
                    x="0" 
                    y="150" 
                    fill="${this.fill}" 
                    transform="rotate(${percent * 1.8})" 
                    style="transform-box: fill-box; transform-origin: 50% 0px;" />
            </g>
        `
    }

    createValue() {
        return `
            <text 
                data-val
                text-anchor="middle" 
                x="50%" y="138" 
                fill="${this.fill}" 
                style="font-size: 50px; font-weight: 900;">${formatValue(this.value, 'percent')}</text>
        `
    }

    render() {
        return `
            <style>
                * {
                    box-sizing: border-box;
                }

                :host {
                    background-color: ${this.bg};
                    border-radius: var(--chart-radius);
                    container-type: inline-size;
                    display: grid;
                    gap: 1.5em;
                    height: 100%;
                    overflow: clip;
                    padding: 3rem;
                    place-content: center;
                    position: relative;
                    -webkit-user-select: none;
                    user-select: none;
                }

                p {
                    margin: 0;
                }

                .heading {
                    color: ${this.fill};
                    font-size: 7cqw;
                    font-weight: 800;
                    text-align: center;
                }

                svg {
                    display: block;
                    height: auto;
                    margin-inline: auto;
                    width: 90%;
                }
            </style>

            ${printWorkAround(this)}

            ${this.createHeading()}

            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                version="1.1" 
                viewBox="0 0 ${this.width} ${this.height}">
                <rect fill="${this.bg}" x="0" y="0" width="${this.width}" height="${this.height}"></rect>
                ${this.createGauge()}
                ${this.createValue()}
            </svg>

            ${(this.hasAttribute('data-help')) ? `<zero-help-button msg="${this.dataset.help}" color="${this.fill.replace('-dk', '')}"></zero-help-button>` : ''}
        `
    }
})